export const GLOBAL_CLEAR_STORE_TYPE = 'GLOBAL_CLEAR_STORE';

/** an action on which all stores must clear their values */
export const GLOBAL_CLEAR_STORE_ACTION = { type: GLOBAL_CLEAR_STORE_TYPE };
